import { getAuditsByAccount } from "../audit/audit.actions";
import { createLoadingAction } from "../loader/loader.actions";

export const fetchAccountActivityLogs = createLoadingAction(
  (customerId, query) => (dispatch) =>
    dispatch(getAuditsByAccount(customerId, query))
);
